/* eslint-disable no-unused-expressions */
/* eslint-disable no-return-assign */
/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { BsFileEarmark } from 'react-icons/bs';
import { cloneDeep } from 'lodash';
import { FormattedMessage, IntlProvider } from 'react-intl';
import CustomReviewSectionSettingsForm from './CustomReviewSection.settingsForm';
import getLocalParams from '../localizationCustoms';
import { addFileNames, getFieldValueAndLabel, addLabelValuePair, setPage } from './utils';
import './CustomReviewSection.scss';

const CustomReviewSection = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.setValue = this.setValue.bind(this);
  }

  componentDidMount() {
    this.sanitizeData(this.props);
    const review = this.getReviewValue();
    this.setValue(review);
    setTimeout(() => {
      document.getElementsByClassName('app')[0].scrollTop = 0;
    }, 100);
  }

  setValue = (v) => {
    const { onChange } = this.props;
    this.setState({ value: v }, () => {
      const { value } = this.state;
      onChange(value);
    });
  };

  getReviewValue = () => {
    const { data, component: { reviewPaths, filePaths, valAsArray } } = this.props;
    const review = { fields: [], files: [] };

    reviewPaths && reviewPaths.trim().split(',').forEach((path) => {
      let label;
      let val;

      if (path.split('.').length > 1) {
        let newData = cloneDeep(data);
        path.split('.').every((key) => {
          if (newData[key]) {
            newData = newData[key];
            if (Object.keys(newData).length === 1 && newData.data) {
              newData = newData.data;
            }
            if (newData?.review) {
              ({ val, label } = getFieldValueAndLabel(newData));
            }
            return true;
          }
          return false;
        });
      } else {
        const field = data[path];
        ({ val, label } = getFieldValueAndLabel(field));
      }

      review.fields.concat(addLabelValuePair(review.fields, label, val, valAsArray));
    });

    filePaths && filePaths.trim().split(',').forEach((path) => {
      const fileNames = addFileNames(path, data);
      review.files = review.files.concat(fileNames);
    });

    return review;
  };

  sanitizeData(props) {
    const { data, component: { sanitizeData } } = props;

    if (sanitizeData) {
      if (data?.claim_type?.claim_type === 'Home' && data?.property?.data) {
        if ((data?.property?.data?.reportedPolice?.value === false) && data.additionalInfoPropertyReview?.fields?.length > 0) {
          data.additionalInfoPropertyReview.fields = data.additionalInfoPropertyReview.fields.filter((item) => item.label === 'Police report');
          if (data.additionalInfoPropertyReview2?.fields) {
            data.additionalInfoPropertyReview2.fields = [];
          }
        }
        if ((data?.property?.data?.reportedFire?.value === false) && data?.additionalInfoPropertyReview3?.fields?.length > 0) {
          data.additionalInfoPropertyReview3.fields = data.additionalInfoPropertyReview3.fields.filter((item) => item.label === 'Fire report');
          if (data?.additionalInfoPropertyReview4?.fields?.length > 0) {
            data.additionalInfoPropertyReview4.fields = data.additionalInfoPropertyReview4.fields.filter((item) => item.label !== 'Department' && item.label !== 'Report No.');
          }
        }
        if (data?.property?.data?.reportedPolice?.value === false) {
          delete data?.property?.data?.file_policeReport;
          delete data?.property?.data?.police;
        }
        if (data?.property?.data?.reportedFire?.value === false) {
          delete data?.property?.data?.fire;
          delete data?.property?.data?.file_fireReport;
        }
      } else if (data?.claim_type?.claim_type === 'Vehicle' && data?.auto?.data.lossCause?.value) {
        if ((data?.auto?.data?.reportedPolice?.value === false) && data?.additionalInfoAutoReview?.fields?.length > 0) {
          data.additionalInfoAutoReview.fields = data.additionalInfoAutoReview.fields.filter((item) => item.label === 'Police report');
          if (data?.additionalInfoAutoReview2?.fields) {
            data.additionalInfoAutoReview2.fields = [];
          }
        }
        if ((data?.auto?.data?.reportedFire?.value === false) && data?.additionalInfoPropertyReview3?.fields?.length > 0) {
          data.additionalInfoAutoReview3.fields = data.additionalInfoAutoReview3.fields.filter((item) => item.label === 'Fire report');
          if (data?.additionalInfoAutoReview4?.fields?.length > 0) {
            data.additionalInfoAutoReview4.fields = data.additionalInfoAutoReview4.fields.filter((item) => item.label !== 'Department' && item.label !== 'Report No.');
          }
        }
        if (data?.auto?.data?.reportedPolice?.value === false) {
          delete data?.auto?.data?.file_policeReport;
          delete data?.auto?.data?.police;
        }
        if (data?.auto?.data?.reportedFire?.value === false) {
          delete data?.auto?.data?.fire;
          delete data?.auto?.data?.file_fireReport;
        }
      } else if (data?.claim_type?.claim_type === 'Vehicle' && data.claim_type?.vehicle?.policySystemId === 'injuryOnly') {
        if ((data?.abonly?.data?.reportedPolice?.value === false) && data?.additionalInfoAbOnlyReview?.fields?.length > 0) {
          data.additionalInfoAbOnlyReview.fields = data.additionalInfoAbOnlyReview.fields.filter((item) => item.label === 'Police report');
        }
        if (data?.abonly?.data?.reportedPolice?.value === false) {
          delete data?.abonly?.data?.file_policeReport;
          delete data?.abonly?.data?.police;
        }
      }
    }
  }

  render() {
    const { component: { key, label, reviewEdit, hideCustomLabel, reviewPage }, data, root } = this.props || undefined;
    const { value } = this.state || undefined;
    const valueToRender = window.sessionStorage.getItem('resumeReview') ? data[key] : (value || data[key]);
    const maskedFields = new Set(['Contact', 'Driver', 'Driver name', 'Issuing province', 'License No.', 'License plate', 'Address', 'Additional details', 'Explanation', 'Owner\'s info', 'Description', 'Contact Info', 'Property']);
    return (
      <div className="claim-review-section review-section-separator">
        {(!hideCustomLabel || reviewEdit) && (
          <div className="claim-review-section--header">
            {!hideCustomLabel && <label className="section-title-review"> <FormattedMessage id={label} defaultMessage={label} /></label>}
            {reviewEdit && reviewEdit !== ''
              && (
                <button
                  type="button"
                  className="edit-button-review"
                  onClick={() => {
                    setPage(root, reviewPage);
                    window.dispatchEvent(new CustomEvent('reviewEdit', {
                      detail: {
                        key: 'setPage',
                        page: reviewPage,
                      },
                    }));
                  }}
                >
                  <FormattedMessage id={reviewEdit} defaultMessage={reviewEdit} />
                </button>
              )}
          </div>
        )}
        <div className="claim-review-section--body">
          {valueToRender && valueToRender.fields && valueToRender.fields.map((field) => {
            const answerStyle = (maskedFields.has(field.label) || field.label?.endsWith('on policy')) ? 'review-answer fs-exclude' : 'review-answer';
            if (typeof field.val === 'object' && field.val) {
              return (
                <div key={field.label} className="claim-review-section--field">
                  <span className="review-question"><FormattedMessage id={field.label} defaultMessage={field.label} />:</span>
                  <span className="multiple-options">
                    {field.val.map((v) => (
                      <span key={`${field.label}_${v}`} className={answerStyle}><FormattedMessage id={v} defaultMessage={v} /></span>
                    ))}
                  </span>
                </div>
              );
            } if (field.val) {
              return (
                <div key={field.label} className="claim-review-section--field">
                  <span className="review-question"><FormattedMessage id={field.label} defaultMessage={field.label} />:</span>
                  <span className={answerStyle}><FormattedMessage id={field.val} defaultMessage={field.val} /></span>
                </div>
              );
            }
            return false;
          })}
          {valueToRender && valueToRender.files && valueToRender.files.length > 0 && (
            <div className="claim-review-section--field file-list">
              <span className="review-question"><FormattedMessage id="Uploads:" defaultMessage="Uploads:" /></span>
              {valueToRender.files.map((file) => (
                <div key={file} className="claim-review-section--field">
                  <span className="review-answer review-answer--file fs-exclude">
                    <div className="file-container"><BsFileEarmark style={{ color: '#323232' }} /></div>
                    {file}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
};

export default class ReviewFieldComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Review Section',
      icon: 'terminal',
      group: 'layout',
      documentation: '',
      schema: ReviewFieldComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customreviewsection',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomReviewSectionSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  async attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    await element.getElementsByTagName('input').value;

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomReviewSection
          ref={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          data={this.data}
          onChange={this.updateValue} // The onChange event to call when the value changes.
          root={this.root}
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  async detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
